import { apiService } from "api/apiService";
import type {
  ClusterStudentResource,
  MyStudentLearningObjectiveResource,
  MyStudentsLearningGoals200,
} from "api/generated";

export const fetchMentorClassLearningGoals = async (
  mentorClass: string,
  periodId: number,
  signal?: AbortSignal,
): Promise<MyStudentLearningObjectiveResource[]> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}/learning-goals`;

  const {
    data: { data },
  } = await apiService.get<MyStudentsLearningGoals200>(url, {
    params: { "period-id": periodId },
    signal,
  });

  return data;
};

export const fetchMentorClassLearningGoalsSubject = async (
  studentId: number,
  scheduleId: number,
  periodId: number,
  signal?: AbortSignal,
): Promise<ClusterStudentResource[]> => {
  const url = `/api/teacher/my-students/learning-objectives/${studentId}/${scheduleId}`;

  const { data } = await apiService.get<ClusterStudentResource[]>(url, {
    params: { "period-id": periodId },
    signal,
  });

  return data;
};
